<template lang="pug">
.image-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .image-modal-body
      img(:src="imageUrl" ref="image")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 画像表示モーダル
 */
@Component
export default class ImageModal extends Vue {
  /** 表示画像URL */
  @Prop({
    default: () => {
      return "";
    }
  })
  private imageUrl!: string;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
